import { Component, Inject, OnInit, ViewEncapsulation } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
  MatSnackBar,
} from "@angular/material";
import { GameSettingsService } from "@app/main/content/game-settings/game-settings.service";
import { FuseSplashScreenService } from "@fuse/services/splash-screen.service";
import { ConfirmationDialogComponent } from "@app/main/content/confirmation-dialog/confirmation-dialog.component";
import { PopupModel } from "@app/main/content/game-settings/popup/popup.model";
import * as _ from "lodash";
import { SurveyModel } from "./survey.model";
import { LowerCasePipe } from "@angular/common";
import { environment } from "@env/environment";
import * as moment from "moment";
@Component({
  selector: "fuse-ad-form",
  templateUrl: "./ad-form.component.html",
  styleUrls: ["./ad-form.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class AdFormComponent implements OnInit {
  dialogTitle: string;
  adForm: FormGroup;
  action: string;
  popup: PopupModel = new PopupModel();
  tabs: any = [
    { label: "SURVEY", value: "survey" },
    { label: "ADMOB", value: "admob" },
    // { label: "MANAD", value: "manad" },
    { label: "URL QUE", value: "que" },
    { label: "QUE", value: "adque" },
  ];
  selectedIndex: number;
  selectedQue = false;
  selectedId: any;
  ques: any[] = [];

  fileNameDialogRef: MatDialogRef<ConfirmationDialogComponent>;

  survey: SurveyModel = new SurveyModel();

  s3BucketUrl: string = environment.s3BucketUrl;

  NOW = moment.now();

  // *URLQUE related code
  selectedURLQue = false;
  urlQues: any[] = [];
  selectedURLQUEId: any;
  // */URLQUE related code

  private selectedQues: { type: "adque" | "que"; data: any[] } = {
    type: "que",
    data: [],
  };

  constructor(
    public dialogRef: MatDialogRef<AdFormComponent>,
    @Inject(MAT_DIALOG_DATA) private data: any,
    private snackBar: MatSnackBar,
    private formBuilder: FormBuilder,
    private dialog: MatDialog,
    private gameSettingsService: GameSettingsService,
    private fuseSplashScreenService: FuseSplashScreenService
  ) {
    this.action = data.action;
    this.quesInitialization();

    // *URLQUE related code
    this.urlQuesInitialization(data.ques);
    // */URLQUE related code

    this.dialogTitle = "AD Info";
    if (this.action === "edit") {
      this.popup = data.popup;

      this.survey =
        this.popup.type === "survey" &&
          Object.keys(this.popup.data).length !== 0
          ? this.popup.data
          : this.survey;

      this.popup.type = this.popup.type.toLocaleLowerCase();

      if (this.popup.type === "survey") {
        this.selectedIndex = 0;
      } else if (this.popup.type === "admob") {
        this.selectedIndex = 1;
      } else if (this.popup.type === "que") {
        // *QUE related code
        this.selectedIndex = 2;
        this.urlQueSelection(this.popup);
        // */QUE related code
      } else if (this.popup.type === "adque") {
        this.selectedIndex = 3;
        this.queSelection();
      }
    } else {
      this.selectedIndex = 0;
      this.popup = new PopupModel();
      this.popup.type = "survey";
    }
  }

  ngOnInit() {
    if (_.isEmpty(this.survey)) {
      this.survey = new SurveyModel();
    }
    this.adForm = this.createAdForm();
    this.setManadUrlValidator();
  }

  queSelection() {
    this.selectedQues = {
      type: "adque",
      data: Array.isArray(this.data.popup.data)
        ? this.data.popup.data
        : [this.data.popup.data],
    };
    this.ques.forEach((que) => {
      const isSelected = this.selectedQues.data.some(
        (item: any) => item.id === que.id
      );
      que.selectedQue = isSelected;
      que.data[0].selectedData = isSelected;
    });
  }

  quesInitialization(ques?: any[]) {
    if (ques) {
      this.ques = ques.filter(
        (content) =>
          content.type === "manual advertisement" &&
          content.categoryId === this.data.gameCategoryId
      );
    } else {
      this.ques = this.gameSettingsService.contents.filter(
        (content) =>
          content.type === "manual advertisement" &&
          content.categoryId === this.data.gameCategoryId
      );
    }
    this.ques = _.orderBy(this.ques, ["createdAt"]);
    this.ques.forEach((que) => {
      que.timeStamp = moment
        .duration(moment().diff(moment(que.createdAt)))
        .humanize();
      que.toggle = false;
      que.selectedQue = false;
      que.data.forEach((data) => {
        data.selectedData = false;
      });
    });
    // this.cdref.detectChanges();
  }

  createAdForm() {
    return this.formBuilder.group({
      popupType: [this.popup.type],
      url: [this.popup && this.popup.data ? this.popup.data.url : undefined],
      selectedQue: [undefined],
      selectedQueId: [
        this.popup && this.popup.data && this.popup.data.id
          ? this.popup.data.id
          : undefined,
      ],
      data: [this.popup && this.popup.data ? this.popup.data : undefined],
      playerId: [
        this.popup &&
          this.popup.data &&
          this.popup.data &&
          this.popup.data.player
          ? this.popup && this.popup.data && this.popup.data.player.id
          : undefined,
      ],
      selectedQuePosition: [undefined],
      survey: [this.survey],
    });
  }

  deleteQueData(data, i, que) {
    data.id = data.id ? data.id : que.id;
    this.fileNameDialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        message: "Are you sure you want to Delete?",
      },
    });
    this.fileNameDialogRef.afterClosed().subscribe((result) => {
      // category deleting on selecting yes from confirmation dialog
      if (result) {
        this.fuseSplashScreenService.show();
        this.gameSettingsService.deleteQue(data).then((updatedData) => {
          if (updatedData.count) {
            this.getContent();
          } else {
            this.updateContent(updatedData);
          }
          this.fuseSplashScreenService.hide();
        });
      }
    });
  }

  getContent() {
    this.gameSettingsService.getContent().then((ques: any[]) => {
      this.quesInitialization(ques);
      this.fuseSplashScreenService.hide();
      this.snackBar.open("que deleted successfully", "OK", {
        verticalPosition: "top",
        duration: 2000,
      });
    });
  }

  updateContent(updatedData) {
    this.gameSettingsService.updateContent(updatedData).then((res) => {
      this.gameSettingsService.getContent().then((ques: any[]) => {
        this.quesInitialization(ques);
        this.fuseSplashScreenService.hide();
        this.snackBar.open("que deleted successfully", "OK", {
          verticalPosition: "top",
          duration: 2000,
        });
      });
    });
  }

  getImagesUrl(image) {
    if (image) return this.s3BucketUrl + image.replace(this.s3BucketUrl, "");
    return "";
  }

  // todo: issue in making manad and adque required
  setManadUrlValidator() {
    let manadUrl = this.adForm.get("url");
    const selectedQue = this.adForm.get("selectedQue");
    this.adForm.get("popupType").valueChanges.subscribe((type) => {
      if (type === "MANAD") {
        if (this.popup.type !== "manad") {
          this.adForm.patchValue({ url: undefined });
          manadUrl = this.adForm.get("url");
        } else if (this.popup.type === "manad") {
          this.adForm.patchValue({ url: this.popup.data.url });
          manadUrl = this.adForm.get("url");
        }
        manadUrl.setValidators([Validators.required]);
        selectedQue.setValidators(null);
      } else if (type === "QUE") {
        if (this.popup.data) {
          this.adForm.patchValue({ url: this.popup.data.url });
          manadUrl = this.adForm.get("url");
        }
        selectedQue.setValidators([Validators.required]);
        manadUrl.setValidators(null);
      } else {
        manadUrl.setValidators(null);
      }
      selectedQue.updateValueAndValidity();
      manadUrl.updateValueAndValidity();
    });
  }

  tabChanged($event) {
    let lowerCasePipe = new LowerCasePipe();
    let popupType = "que";
    const textLabel = $event.tab.textLabel;

    if (textLabel !== "URL QUE" && textLabel !== "QUE") {
      popupType = lowerCasePipe.transform(textLabel);
    } else if (textLabel === "QUE") {
      popupType = "adque";
    }

    this.adForm.patchValue({
      popupType: popupType,
    });
  }

  selectQueData(selectedQue, data, index) {
    this.updateSelectedQues(
      { value: "adque" },
      { ...data, id: selectedQue.id, playerId: selectedQue.player.id }
    );
    this.adForm.patchValue({
      selectedQue: true,
      selectedQueId: selectedQue.id,
      data: this.selectedQues.data,
      playerId: selectedQue.player.id,
      selectedQuePosition: data.position,
    });
    console.log('selectedQues...', this.selectedQues);
    this.ques.forEach((que) => {
      const isSelected = this.selectedQues.data.some(
        (item: any) => item.id === que.id
      );
      que.selectedQue = isSelected;
      que.data.forEach((el) => {
        el.selectedData =
          isSelected;
      });
    });
  }

  buttonToggle(que) {
    que.toggle = !que.toggle;
  }

  linkContainer(que, index) {
    if (index === 0) {
      return true;
    } else {
      return !!(index > 0 && que.toggle);
    }
  }

  checkValidation() {
    this.adForm.patchValue({ survey: this.survey });
    let formData = this.adForm.getRawValue();

    if (formData.popupType === "survey") {
      if (this.survey.question === "") {
        this.snackBar.open("Please enter survey question", "ERROR", {
          verticalPosition: "top",
          duration: 2000,
        });
      } else if (this.survey.image && this.survey.image.file === null) {
        this.snackBar.open("Please Upload Survey Image", "ERROR", {
          verticalPosition: "top",
          duration: 2000,
        });
      } else if (
        this.survey.choices &&
        this.survey.choices.filter((el) => el.image && el.image.file === null)
          .length !== 0
      ) {
        this.snackBar.open("Please Upload Choices Image", "ERROR", {
          verticalPosition: "top",
          duration: 2000,
        });
      } else if (
        this.survey.comments.length > 0 &&
        (this.survey.comments[0].question === "" ||
          this.survey.comments[0].comments[0].value === "" ||
          this.survey.comments[0].comments[1].value === "")
      ) {
        // Your logic here
        this.snackBar.open(
          "The first question and its initial two comments are mandatory.",
          "ERROR",
          {
            verticalPosition: "top",
            duration: 2000,
          }
        );
      } else if (
        this.survey.comments.some(
          (el) =>
            el.question !== "" &&
            el.comments.filter((comment) => comment.value === "").length > 2 // Check if at least two comments have non-empty values
        )
      ) {
        // Your logic here
        this.snackBar.open(
          "Please ensure that at least two comments are added per page when a question is entered.",
          "ERROR",
          {
            verticalPosition: "top",
            duration: 2000,
          }
        );
      } else {
        this.dialogRef.close(this.adForm);
      }
    } else {
      this.dialogRef.close(this.adForm);
    }
  }

  // *URLQUE related code
  /**
   * TODO: will filter content in ascending order of that specific categoryId while calling content API
   * @param ques
   */
  urlQuesInitialization(ques?: any[]) {
    this.urlQues = ques.filter(
      (content) =>
        content.type === "shareable content" &&
        content.categoryId === this.data.gameCategoryId
    );
    // TODO: be removed when filter is called through content api
    this.urlQues = _.orderBy(this.urlQues, ["createdAt"], ["desc"]);
    this.urlQues.forEach((que) => {
      que.timeStamp = moment
        .duration(moment().diff(moment(que.createdAt)))
        .humanize();
      que.toggle = false;
      que.selectedQue = false;
      que.data.forEach((data) => {
        data.selectedData = false;
      });
    });
  }

  urlQueSelection(content) {
    this.selectedQues = {
      type: "que",
      data: Array.isArray(content.data) ? content.data : [content.data],
    };
    this.urlQues.forEach((que) => {
      const isSelected = this.selectedQues.data.some(
        (item: any) => item.id === que.id
      );
      que.selectedQue = isSelected;
      que.data.forEach((el) => {
        el.selectedData = isSelected;
      });
    });
  }
  // */URLQUE related code

  updateSelectedQues(tab: any, data: any) {
    const type = tab.value; // 'que' | 'adque'

    // If same type
    if (this.selectedQues.type === type) {
      const index = this.selectedQues.data.findIndex(
        (item: any) => item.id === data.id
      );

      if (index !== -1) {
        // If exists → REMOVE it
        this.selectedQues.data.splice(index, 1);
      } else {
        // If does not exist → ADD it
        this.selectedQues.data.push(data);
      }
    } else {
      // If different type → reset and insert fresh data
      this.selectedQues = {
        type,
        data: [data],
      };
    }
  }

  // *QUE related code
  selectUrlQueData(selectedQue, data, index) {
    this.updateSelectedQues(
      { value: "que" },
      { ...data, id: selectedQue.id, playerId: selectedQue.player.id, playerImage: selectedQue.player.profileImage }
    );
    this.adForm.patchValue({
      data: this.selectedQues.data,
      selectedQue: true,
      selectedQueId: selectedQue.id,
      queUrl: data.url,
      playerId: selectedQue.player.id,
      selectedQuePosition: data.position,
    });
    this.urlQues.forEach((que) => {
      const isSelected = this.selectedQues.data.some(
        (item: any) => item.id === que.id
      );
      que.selectedQue = isSelected;
      que.data.forEach((el) => {
        el.selectedData = isSelected;
      });
    });
  }

  /**
   * neeed to be updated with new design changes
   * @param data
   * @param i
   * @param que
   */
  deleteUrlQueData(data, i, que) {
    data.id = data.id ? data.id : que.id;
    this.fileNameDialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        message: "Are you sure you want to Delete?",
      },
    });
    this.fileNameDialogRef.afterClosed().subscribe((result) => {
      // category deleting on selecting yes from confirmation dialog
      if (result) {
        this.fuseSplashScreenService.show();
        this.gameSettingsService.deleteQue(data).then((updatedData) => {
          if (updatedData.count) {
            this.getContent();
          } else {
            this.updateContent(updatedData);
          }
          this.fuseSplashScreenService.hide();
        });
      }
    });
  }

  getURLQUEContent() {
    this.gameSettingsService.getContent().then((ques: any[]) => {
      this.urlQuesInitialization(ques);
      this.fuseSplashScreenService.hide();
      this.snackBar.open("que deleted successfully", "OK", {
        verticalPosition: "top",
        duration: 2000,
      });
    });
  }

  updateURLQUEContent(updatedData) {
    this.gameSettingsService.updateContent(updatedData).then((res) => {
      this.gameSettingsService.getContent().then((ques: any[]) => {
        this.urlQuesInitialization(ques);
        this.fuseSplashScreenService.hide();
        this.snackBar.open("que deleted successfully", "OK", {
          verticalPosition: "top",
          duration: 2000,
        });
      });
    });
  }

  URLQUEbuttonToggle(que) {
    que.toggle = !que.toggle;
  }

  URLQUElinkContainer(que, index) {
    if (index === 0) {
      return true;
    } else {
      return !!(index > 0 && que.toggle);
    }
  }
  // */QUE related code
}
